// extracted by mini-css-extract-plugin
export default {"wrapperAnalytics":"aviation_wrapperAnalytics__UPnLm","metric":"aviation_metric__v+lFb"};